import React from 'react';

import styles from './index.module.scss';
import {
  RecommendHelpHeader,
  RecommendHelpCalculator
} from '../../components/recommend-help/index.troy';

import { connectTo } from '../../utils';
import { getUser, sendCalculatorInfo } from '../../actions';

class RecommendHelp extends React.Component {
  onSubmit = values => {
    const { currency, sendCalculatorInfo } = this.props;
    sendCalculatorInfo({ currency, ...values });
  };

  render() {
    const {
      currency,
      balance,
      firstName,
      lastName,
      email,
      mobilePhone,
      phone
    } = this.props;

    return (
      <div className={styles['recommend-help__wrapper']}>
        <div className={styles['recommend-help__content']}>
          <RecommendHelpHeader />
          <RecommendHelpCalculator
            {...{ firstName, lastName, currency, balance, email, mobilePhone, phone }}
            onSubmit={this.onSubmit}
          />
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    payment: {
      paymentUserInfo: { dueCurrency, totalBalance }
    },
    form: { calculator },
    profile: { firstname, lastname, email, mobilePhone, phone }
  }) => ({
    currency: dueCurrency,
    balance: totalBalance,
    firstName: firstname,
    lastName: lastname,
    email,
    mobilePhone,
    phone,
    calculator
  }),
  { getUser, sendCalculatorInfo },
  RecommendHelp
);
